<script>
import Home from './pages/Home.vue';

export default {
  name: 'App',
  components: {
    Home
  }
};
</script>

<template>
  <div id="app">
    <Home />
  </div>
</template>
